export interface SendKycSmsPayload {
  userId: string;
  cellphone: string;
  countryCode: string;
}

export interface Kyc {
  id: string;
  createdAt: Date;
  updatedAt: Date;
  submissionId: number;
  submissionStatusCode: number;
  completed: boolean;
  kycApproved: boolean;
  ageApproved: boolean;
  userId: string;
  kycUrl: string | null;
}

export interface GenerateApplinkResponse {
  applink: string;
}

export enum KycStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  ON_HOLD = 'ON_HOLD',
}

export interface GenerateAccessToken {
  id: string;
  createdAt: Date;
  updatedAt: Date;
  accessToken: string;
  status: KycStatus | null;
  kycId: string;
}
